export default "__VITE_ASSET__yTYPV4PF__"